import { BalanceWithLoading, Flex, Message, Text, TooltipText, useTooltip } from '@pancakeswap/uikit'
import { useAccount } from 'wagmi'
import { useTranslation } from '@pancakeswap/localization'
import useWithdrawalFeeTimer from 'views/Pools/hooks/useWithdrawalFeeTimer'
import { secondsToHours } from 'date-fns'
import { useVaultPoolByKey } from 'state/pools/hooks'
import { secondsToDay } from 'utils/timeHelper'
import { VaultKey } from 'state/types'
import WithdrawalFeeTimer from './WithdrawalFeeTimer'
import { ActionContent, ActionTitles } from '../PoolsTable/ActionPanel/styles'

interface UnstakingFeeCountdownRowProps {
  vaultKey: VaultKey
}

const UnstakingFeeCountdownRow: React.FC<React.PropsWithChildren<UnstakingFeeCountdownRowProps>> = ({
  vaultKey,
}) => {
  const { t } = useTranslation()
  const { address: account } = useAccount()
  const {
    userData: { lastDepositedTime, userShares },
    fees: { withdrawalFee, withdrawalFeePeriod },
  } = useVaultPoolByKey(vaultKey)

  const feeAsDecimal = withdrawalFee / 100 || '-'
  const withdrawalDayPeriod = withdrawalFeePeriod ? secondsToDay(withdrawalFeePeriod) : '-'
  const { targetRef, tooltip, tooltipVisible } = useTooltip(
    <>
      <Text bold mb="4px">
        {t('Unstaking fee: %fee%%', { fee: feeAsDecimal })}
      </Text>
      <Text>
        {t(
          'Only applies within %num% days of staking. Unstaking after %num% days will not include a fee. Timer resets every time you stake new tokens in the pool.',
          {
            num: withdrawalDayPeriod,
          },
        )}
      </Text>
    </>,
    { placement: 'bottom-start' },
  )

  const { secondsRemaining, hasUnstakingFee } = useWithdrawalFeeTimer(
    parseInt(lastDepositedTime, 10),
    userShares,
    withdrawalFeePeriod,
  )

  // The user has made a deposit, but has no fee
  const noFeeToPay = lastDepositedTime && !hasUnstakingFee && userShares.gt(0)

  // Show the timer if a user is connected, has deposited, and has an unstaking fee
  const shouldShowTimer = account && lastDepositedTime && hasUnstakingFee

  const withdrawalFeePeriodHour = withdrawalFeePeriod ? secondsToHours(withdrawalFeePeriod) : '-'

  // const getRowText = () => {
  //   if (noFeeToPay) {
  //     return t('Unstaking Fee')
  //   }
  //   if (shouldShowTimer) {
  //     return t('unstaking fee before')
  //   }
  //   return t('unstaking fee if withdrawn within %num%h', { num: withdrawalFeePeriodHour })
  // }

  return (
    noFeeToPay 
      ? null 
      : <Flex flexDirection="column">
          <ActionTitles>
            <Text fontSize="12px" bold color="secondary" as="span" textTransform="uppercase">
              Unstaking Fee
            </Text>
          </ActionTitles>
          <ActionContent mt="8px">
            <Flex flexDirection="column" alignSelf="flex-start">
              <BalanceWithLoading lineHeight="1" bold fontSize="20px" decimals={1} value={feeAsDecimal} unit="%" />
              {
                shouldShowTimer 
                ? <Text fontSize="12px" color="textSubtle">
                    Before&nbsp;<WithdrawalFeeTimer secondsRemaining={secondsRemaining} />
                  </Text>
                : <Text fontSize="12px" color="textSubtle">
                    Within {withdrawalFeePeriodHour} hours
                  </Text>
              }
            </Flex>
          </ActionContent>
        </Flex> 
    // <Flex
    //   alignItems={isTableVariant ? 'flex-start' : 'center'}
    //   justifyContent="space-between"
    //   flexDirection={isTableVariant ? 'column' : 'row'}
    // >
    //   {tooltipVisible && tooltip}
    //   <TooltipText ref={targetRef} small textTransform="lowercase">
    //     {noFeeToPay ? '0' : feeAsDecimal}% {getRowText()}
    //   </TooltipText>
    //   {shouldShowTimer && <WithdrawalFeeTimer secondsRemaining={secondsRemaining} />}
    // </Flex>
  )
}

export default UnstakingFeeCountdownRow
